import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import ServicesRender from "./services";
import Footer from "../footer";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import {t} from "@lingui/core/macro";

export default class Services extends Component{
    render(){
        const context=this.props.context
        const {org,config}=context
        const title=t`Services de ${org.name}`
        const description=t`Services de ${org.name}`

        if(this.props.loading){
            return (
                <div>
                    <Meta context={context} title={title} description={description}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div>
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <PageTitle context={context} title={t`Activités`} color="#D65DB1"/>
                <div className="container" style={{marginTop: 20,minHeight:"50vh"}}>
                    <ServicesRender context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
